import * as am5 from '@amcharts/amcharts5';
import * as am5xy from '@amcharts/amcharts5/xy';
import { noop } from 'lodash';
import {
    DatiqGraphSeriesPatternTypes,
    IDatiqGraph,
    IDatiqGraphSeries,
} from '../models';
import { DatiqAmcharts5TooltipBuilder } from './datiq-amcharts-5-tooltip.builder';
import { datiqAmcharts5SetColor } from './models';

export class DatiqAmCharts5SeriesColumnBuilder {
    private _settings: Partial<am5xy.IColumnSeriesSettings>;
    constructor() {}

    setDefault(series: am5xy.ColumnSeries): this {
        series.setAll({
            clustered: false,
            stacked: true,
        });
        return this;
    }

    setPattern(
        series: am5xy.ColumnSeries,
        root: am5.Root,
        seriesData: IDatiqGraphSeries
    ) {
        if (!seriesData.pattern?.length) return this;

        return seriesData.pattern === DatiqGraphSeriesPatternTypes.Striped
            ? this.setStripedPattern(series, root, seriesData)
            : this;
    }
    setStripedPattern(
        series: am5xy.ColumnSeries,
        root: am5.Root,
        seriesData: IDatiqGraphSeries
    ): this {
        series.columns.template.set(
            'fillPattern',
            am5.LinePattern.new(root, {
                color: this.getStripedPatternLineColor(seriesData),
                rotation: 60,
                width: 500,
                height: 1000,
                gap: 8,
                fillOpacity: 1,
                strokeWidth: 2,
            })
        );

        return this;
    }

    private getStripedPatternLineColor(
        seriesData: IDatiqGraphSeries
    ): am5.Color {
        return !!seriesData?.patternStripeColor?.length
            ? datiqAmcharts5SetColor(seriesData.patternStripeColor)
            : datiqAmcharts5SetColor('#ffffff');
    }

    setColor(series: am5xy.ColumnSeries, seriesData: IDatiqGraphSeries): this {
        !!seriesData?.color?.length
            ? series.setAll({
                  fill: datiqAmcharts5SetColor(seriesData.color),
                  stroke: datiqAmcharts5SetColor(seriesData.color),
              })
            : noop();
        return this;
    }

    setTooltip(
        series: am5xy.ColumnSeries,
        root: am5.Root,
        seriesData: IDatiqGraphSeries,
        graph: IDatiqGraph
    ): this {
        if (!seriesData.showTooltip) return this;

        const tooltip: am5.Tooltip = new DatiqAmcharts5TooltipBuilder(
            series,
            root,
            seriesData,
            graph
        )
            .setLabel(graph, seriesData)
            .build();

        series.set('tooltip', tooltip);
        this.setTooltipPositioningColumn(series);
        return this;
    }

    setTooltipPositioningColumn(series: am5xy.ColumnSeries): void {
        const toolTip = series.get('tooltip');
        const chartHeaderOffset = 15;
        toolTip.events.on(
            'globalpointermove',
            (evt: am5.ISpritePointerEvent) => {
                const yPosition = evt?.target?.y() ?? 0;
                const height = evt?.target?.height();
                toolTip.set('pointerOrientation', 'down');
                toolTip.set('dy', -yPosition - height / 2 + chartHeaderOffset);
            }
        );
    }
}
